import { render, staticRenderFns } from "./WelfareMallAuthentication.vue?vue&type=template&id=7c21d5b8&scoped=true"
import script from "./WelfareMallAuthentication.vue?vue&type=script&lang=js"
export * from "./WelfareMallAuthentication.vue?vue&type=script&lang=js"
import style0 from "./WelfareMallAuthentication.vue?vue&type=style&index=0&id=7c21d5b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c21d5b8",
  null
  
)

export default component.exports